module.exports = __webpack_public_path__ + "img/Free consultation.svg";